import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {AssetWriteOff, AssetWriteOffSearchParams} from '@accounting/_common/models/asset-write-off.models';

export const CheckState = createAction(
    '[AssetWriteOffs] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: AssetWriteOff[] } }>()
);

export const CheckStateSuccess = createAction(
    '[AssetWriteOffs] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: AssetWriteOff[] } }>()
);

export const LoadList = createAction(
    '[AssetWriteOffs] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[AssetWriteOffs] Load List Success',
    props<{ payload: { items: AssetWriteOff[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[AssetWriteOffs] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[AssetWriteOffs] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[AssetWriteOffs] Set Filter',
    props<{ payload: AssetWriteOffSearchParams }>()
);

export const SetLoading = createAction(
    '[AssetWriteOffs] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[AssetWriteOffs] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[AssetWriteOffs] Update Item Success',
    props<{ payload: AssetWriteOff }>()
);

export const DeleteItem = createAction(
    '[AssetWriteOffs] Delete Item',
    props<{ payload: AssetWriteOff }>()
);

export const DeleteItemSuccess = createAction(
    '[AssetWriteOffs] Delete Item Success',
    props<{ payload: AssetWriteOff }>()
);

export const DeleteItemFailure = createAction(
    '[AssetWriteOffs] Delete Item Failure',
    props<{ payload: AssetWriteOff }>()
);

export const SetInitialState = createAction(
    '[AssetWriteOffs] Set Initial State'
);
